import { render, staticRenderFns } from "./ServiceComp.vue?vue&type=template&id=1f0e94be&scoped=true&"
import script from "./ServiceComp.vue?vue&type=script&lang=js&"
export * from "./ServiceComp.vue?vue&type=script&lang=js&"
import style0 from "./ServiceComp.vue?vue&type=style&index=0&id=1f0e94be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0e94be",
  null
  
)

export default component.exports